import { motion } from "framer-motion";
import { ASSESSMENT_FACTORS } from "@/data/content";

const LEFT_FACTORS = ASSESSMENT_FACTORS.slice(0, 4);
const RIGHT_FACTORS = ASSESSMENT_FACTORS.slice(4);

export const WhatWeEvaluate = () => (
  <section data-testid="what-we-evaluate-section" className="bg-surfaceLight px-6 py-[30px] sm:py-[32px] lg:px-12 lg:py-[56px]">
    <div className="lg:mx-auto lg:max-w-[1280px]">
      <div className="max-w-2xl lg:mx-auto lg:max-w-none lg:text-center">
        <h2
          data-testid="what-we-evaluate-headline"
          className="font-heading text-[28px] font-semibold leading-tight text-ink sm:text-[32px] lg:text-[36px]"
        >
          The metrics that matter
        </h2>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-x-16 sm:grid-cols-2 lg:mt-12">
        {[LEFT_FACTORS, RIGHT_FACTORS].map((column, colIndex) => (
          <div key={colIndex} className="divide-y divide-borderLight border-t border-borderLight">
            {column.map((factor, i) => (
              <motion.div
                key={factor.n}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                data-testid={`assessment-factor-${factor.n}`}
                className={`flex items-baseline gap-5 pt-7 ${factor.n === "07" ? "pb-[8px] sm:pb-7" : "pb-7"}`}
              >
                <span className="font-heading text-3xl font-semibold text-ink/15 lg:text-4xl">{factor.n}</span>
                <div>
                  <h3 className="font-heading text-lg font-semibold text-ink">{factor.title}</h3>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-inkSoft">{factor.body}</p>
                </div>
              </motion.div>
            ))}
          </div>
        ))}
      </div>
    </div>
  </section>
);
